export default __webpack_public_path__ + "static/Merriweather-Regular-b3a5b31ecc7537ef287fecf2f240fd20.woff2";